var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudioColorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.37,
    height: 22.76,
    viewBox: "0 0 17.37 22.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Audio",
    transform: "translate(-2.13 -0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2120",
    "data-name": "Path 2120",
    d: "M19.49,22.08a.681.681,0,0,1-.67.69H2.8a.681.681,0,0,1-.67-.69V.7A.687.687,0,0,1,2.8.01H14.61c.87.93,4.51,4.47,4.88,4.94V22.07Z",
    fill: "#e0f4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2121",
    "data-name": "Path 2121",
    d: "M19.49,15.86H2.14v6.2a.681.681,0,0,0,.67.69H18.83a.681.681,0,0,0,.67-.69V15.87Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2122",
    "data-name": "Path 2122",
    d: "M14.65.02V4.31a.628.628,0,0,0,.62.61h4.18Z",
    fill: "#99badb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2123",
    "data-name": "Path 2123",
    d: "M12.32,6.4a.406.406,0,0,0-.37-.07L8.71,7.2a.525.525,0,0,0-.39.51v3.67a.255.255,0,0,1-.18.24h0l-.85.29a.791.791,0,0,0-.53.76.91.91,0,0,0,.38.74.875.875,0,0,0,.52.17.929.929,0,0,0,.29-.05h0l.35-.13a.772.772,0,0,0,.53-.73V9.22a.245.245,0,0,1,.2-.24h0l2.84-.76a.075.075,0,0,1,.08.05V10.6a.255.255,0,0,1-.18.24h0l-.83.3a.808.808,0,0,0-.55.77.91.91,0,0,0,.38.74.9.9,0,0,0,.81.12h0l.35-.13a.772.772,0,0,0,.53-.73V6.74a.422.422,0,0,0-.17-.34Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2124",
    "data-name": "Path 2124",
    d: "M6.41,20.58H5.26l-.24.69H4.48L5.6,18.3h.46l1.12,2.97H6.64l-.24-.69Zm-1-.42h.86l-.43-1.23-.43,1.23Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2125",
    "data-name": "Path 2125",
    d: "M9.67,18.3v1.98a1.063,1.063,0,0,1-.09.45.963.963,0,0,1-.24.32.918.918,0,0,1-.35.19,1.54,1.54,0,0,1-.43.06,1.56,1.56,0,0,1-.44-.06.984.984,0,0,1-.35-.19.755.755,0,0,1-.23-.32,1.064,1.064,0,0,1-.08-.45V18.3h.51v1.98a.7.7,0,0,0,.04.27.615.615,0,0,0,.12.19.4.4,0,0,0,.19.11,1,1,0,0,0,.25.04.69.69,0,0,0,.25-.04.5.5,0,0,0,.19-.11.516.516,0,0,0,.12-.19.766.766,0,0,0,.04-.27V18.3h.51Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2126",
    "data-name": "Path 2126",
    d: "M10.22,21.27V18.3h.88a1.311,1.311,0,0,1,.96.38,1.164,1.164,0,0,1,.27.44,1.536,1.536,0,0,1,.1.58v.15a1.536,1.536,0,0,1-.1.58,1.185,1.185,0,0,1-.28.44,1.146,1.146,0,0,1-.43.28,1.433,1.433,0,0,1-.56.1h-.85Zm.52-2.55v2.14h.34a.873.873,0,0,0,.37-.07.65.65,0,0,0,.26-.2,1.01,1.01,0,0,0,.16-.31,1.345,1.345,0,0,0,.05-.42v-.15a1.145,1.145,0,0,0-.21-.74.743.743,0,0,0-.61-.26h-.36Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2127",
    "data-name": "Path 2127",
    d: "M13.49,21.27h-.51V18.3h.51Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2128",
    "data-name": "Path 2128",
    d: "M16.49,19.86a1.909,1.909,0,0,1-.09.61,1.224,1.224,0,0,1-.25.45,1.242,1.242,0,0,1-.39.29,1.3,1.3,0,0,1-1,0,1.107,1.107,0,0,1-.39-.29,1.311,1.311,0,0,1-.25-.45,1.866,1.866,0,0,1-.09-.61v-.15a1.909,1.909,0,0,1,.09-.61,1.359,1.359,0,0,1,.25-.46,1.107,1.107,0,0,1,.39-.29,1.3,1.3,0,0,1,1,0,1.107,1.107,0,0,1,.39.29,1.359,1.359,0,0,1,.25.46,1.909,1.909,0,0,1,.09.61Zm-.52-.15a1.9,1.9,0,0,0-.05-.44.94.94,0,0,0-.14-.32.525.525,0,0,0-.23-.19.735.735,0,0,0-.3-.07.6.6,0,0,0-.3.07.834.834,0,0,0-.23.19.725.725,0,0,0-.14.32,1.9,1.9,0,0,0-.05.44v.15a1.9,1.9,0,0,0,.05.44.94.94,0,0,0,.14.32.63.63,0,0,0,.23.2.6.6,0,0,0,.3.07.627.627,0,0,0,.53-.26,1.258,1.258,0,0,0,.18-.76v-.15Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioColorIcon);
export default __webpack_public_path__ + "static/media/audio-color-icon.dce56d4dc9a7b6ecbd8d50372dd6da8a.svg";
export { ForwardRef as ReactComponent };